<template>
  <a-base-component :subscribed_modules="subscribed_modules">
    <template v-slot:default>
      <a-restaurant-sales-resume
        v-if="tab_view === 'resume'"
      ></a-restaurant-sales-resume>
      <a-restaurant-sales-table
        v-if="tab_view === 'table'"
      ></a-restaurant-sales-table>
    </template>
    <template v-slot:loading>
      <a-card :title="$t('Sales')" class="pa-4" no_title>
        <v-row>
          <v-col v-for="i in 4" :key="i" cols="12" md="6">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
        </v-row>
      </a-card>
    </template>
  </a-base-component>
</template>

<script>
import aBaseComponent from "@/components/aBaseComponent.vue";
import aCard from "@/components/aCard.vue";
import aRestaurantSalesResume from "@/components/restaurant/aRestaurantSalesResume.vue";
import aRestaurantSalesTable from "@/components/restaurant/aRestaurantSalesTable.vue";

export default {
  name: "a-restaurant-sales",
  components: {
    aBaseComponent,
    aCard,
    aRestaurantSalesTable,
    aRestaurantSalesResume
  },
  props: {
    tab_view: {
      type: String,
      default: "resume"
    }
  },
  data: () => ({
    subscribed_modules: [
      "restaurant_sales_report_data",
      "restaurant_sales_report_list"
    ]
  })
};
</script>
